export function stripHtmlTags(str: string) {
  var div = document.createElement("div")
  div.innerHTML = str
  return div.textContent || div.innerText || ""
}
